import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Productos } from '@segurosvoluntarios_vel/commons-services/src/prospecto';
import { MedioDePago } from 'src/app/pago/enums/MedioDePago.enum';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { ResumenDescuentos } from 'src/app/pago/models/ResumenDescuentos.model';
import { TextoMetodopago } from '../../enums/TextMetodoPago.enum';

@Component({
  selector: 'app-otro-medio-de-pago',
  templateUrl: './otro-medio-de-pago.component.html',
  styleUrls: ['./otro-medio-de-pago.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OtroMedioDePagoComponent implements OnInit {
  readonly MEDIO_PAGO_PLACE_TO_PAY = MedioDePago.PLACE_TO_PAY;
  readonly MEDIO_PAGO_BANCOLOMBIA = MedioDePago.BANCOLOMBIA;
  @Input() configuracionDePago: ConfiguracionDePago;
  @Input() resumenDescuentos: ResumenDescuentos;
  @Input() formularioMedioDePago: FormControl;
  @Input() submitted: boolean;
  @Output() handlePagarOtroMedio: EventEmitter<any> = new EventEmitter();
  esProductoSoat: boolean = false;

  ngOnInit(): void {
    this.esProductoSoat =
      this.configuracionDePago.idProducto === Productos.SOAT;
  }

  onPagarOtroMedio() {
    this.handlePagarOtroMedio.emit();
  }

  MedioDePagoTexto(): string {
    const medioPago = this.configuracionDePago.mediosPagoHabilitados;

    if (medioPago.tarjetaCredito && medioPago.pse && !this.esProductoSoat) {
      return TextoMetodopago.PSE_TARJETA_CREDITO;
    }

    if (medioPago.tarjetaCredito && !this.esProductoSoat) {
      return TextoMetodopago.TARJETA_CREDITO;
    }

    if (medioPago.pse) {
      return TextoMetodopago.PSE;
    }

    return TextoMetodopago.NO_DISPONIBLE;
  }
}
